/*
<summary>
   This functional component is all about rendering the Add/Edit Tool Check Item Template popup visibility wrapper.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import React, { useState } from 'react';

/**
* This function is used to wrap a component with add/edit popup show/hide state and toggle handler.
* @param Component: Component to wrap with the popup visibility state
*/
const AddToolCheckItemTemplatePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddCheckItemTemplatePopup, setShowAddCheckItemTemplatePopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddCheckItemTemplatePopup(!showAddCheckItemTemplatePopup);
    };

    return (
      <Component
        showAddCheckItemTemplatePopup={showAddCheckItemTemplatePopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddToolCheckItemTemplatePopupHOC;
